import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { SideBySideBlock as SideBySideBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const SideBySideBlock = (
    block: Immutable<{ value: SideBySideBlockValue }>,
): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.sideBySideBlock,
            getGlobalSpacingClasses(block.value.spacing),
        ])}
    >
        {block.value.heading ? <h3>{block.value.heading}</h3> : null}
        {(block.value.sides ?? []).map((side, index, sides) => (
            <React.Fragment key={index}>
                <div className={styles.sideBySideSide}>
                    <h3>{side.heading}</h3>
                    <p>{side.copy}</p>
                    {side.callout && side.hide_callout === false ? (
                        <span className={styles.sideBySideCallout}>
                            {side.callout}
                        </span>
                    ) : null}
                    {side.image ? (
                        <img
                            src={side.image.url}
                            alt={side.image.title}
                            loading="lazy"
                            decoding="async"
                        />
                    ) : null}
                </div>
                {index < sides.length - 1 ? (
                    <span aria-label="versus">vs.</span>
                ) : null}
            </React.Fragment>
        ))}
    </section>
);
